import React, { useState } from 'react';
import LazyImage from "../../Common/LazyImage";

const CardImage = ({ src, alt, onClick, className }) => {
    const [loaded, setLoaded] = useState(false);

    // Show placeholder until the real image has loaded. We pass
    // dataSrc (the real image) and placeholder to LazyImage.
    return (
        <LazyImage
            dataSrc={src}
            placeholder={loaded ? src : '/assets/images/back_cut.png'}
            alt={alt}
            className={className}
            onClick={onClick}
            onLoad={() => setLoaded(true)}
        />
    );
};

export default CardImage;
